import _ from 'lodash'

const ConfigSingleton = (() => {
	let instance

	function Config(config) {
		return {
			get: () => {
				return config
			},
			getConfig: (property, configDefault = null) => {
				return _.get(config, property, configDefault)
			}
		}
	}

	return {
		getInstance: () => {
			return instance
		},
		init: (config) => {
			instance = new Config(config)
		}
	}
})()

export default ConfigSingleton
